// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".device-uploader[data-v-3ce7d028]{opacity:0;position:absolute;top:0;bottom:0;left:0;right:0;cursor:pointer;width:inherit;height:inherit}.device-uploader[data-v-3ce7d028]::file-selector-button{cursor:pointer !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
